import React from "react";
import { size } from "styled-theme";
import { useSelector } from "react-redux";
import { nimbleThemes } from "@src/theme/config";
import styled from "styled-components";

const TrustPilotWrapper = styled.div`
  padding-right: 15px;
  display: ${(props) => (props.$shouldShowBadge ? "block" : "none")};

  @media only screen and (max-width: ${size("S")}) {
    padding: 25px 0px 10px;
  }
`;

export default function BadgeTrustPilot() {
  const themeName = useSelector((state) => state.StartUp.theme.themeName);
  const shouldShowBadge = !nimbleThemes.includes(themeName);

  return (
    <TrustPilotWrapper $shouldShowBadge={shouldShowBadge}>
      {shouldShowBadge && (
        <div
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="54197383fd9dceac42a68694"
          data-businessunit-id="591557fc0000ff0005a24dfc"
          data-style-width="100%"
          data-style-size="S"
          data-token="8e919928-49c8-4248-8cf4-e55c3b7e1812"
          data-text-color="dark"
          data-headline="word"
          data-support-text="star"
          data-background="light"
          data-external-elements-color="dark"
        >
          <a
            href="https://www.trustpilot.com/review/fairgofinance.com.au"
            target="_blank"
            rel="noopener"
          >
            Trustpilot
          </a>
        </div>
      )}
    </TrustPilotWrapper>
  );
}
